'use client';

import { useCurrentSeason } from '@/hooks/use-current-season';
import type { ReactNode } from 'react';

function SeasonPoller() {
  useCurrentSeason();
  return null;
}

interface SeasonProviderProps {
  children: ReactNode;
}

/**
 * Lightweight provider that polls the current season API.
 * Non-blocking — renders children immediately while the fetch runs.
 */
export function SeasonProvider({ children }: SeasonProviderProps) {
  return (
    <>
      <SeasonPoller />
      {children}
    </>
  );
}
